export {default as DetectOutsideClicks} from './detect-outside';
